import { render, staticRenderFns } from "./coachBanList.vue?vue&type=template&id=37961917&scoped=true"
import script from "./coachBanList.vue?vue&type=script&lang=ts"
export * from "./coachBanList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37961917",
  null
  
)

export default component.exports